export enum PaymentType {
  CREDIT_CARD = 'CREDIT_CARD',
  BILLING_PROFILE = 'BILLING_PROFILE',
  LODGE_CARD = 'LODGE_CARD',
}

export enum SalesModel {
  PASS_THROUGH = 'PASS_THROUGH',
  ADD_MARKUP = 'ADD_MARKUP',
}
